import React, { Component } from "react";
import StarRatingComponent from "react-star-rating-component";

export default class Profile extends Component {
  render() {
    return (
      <div className="pt-3">
        <div className="container">
          <div className="card card-body">
            <div class="row mx-3">
              <div class="col-md-2 p-0 d-flex justify-content-center align-items-center">
                <img
                  class="trainer-image"
                  src="https://media.istockphoto.com/photos/happy-laughing-man-picture-id544358212?k=6&m=544358212&s=612x612&w=0&h=odURMNz2hty8LIfpVahaaUKpGU4vd-UlZx4jy-OAnJA="
                  alt="Card"
                />
              </div>
              <div class="col-md-6 d-flex align-items-center">
                <div className="pt-3">
                  <h2>Nicole Pearson</h2>
                  <StarRatingComponent name="rate1" value={4.5} />
                  <p>
                    <strong>Subjects: </strong>
                    <span class="tags ml-1">Maths</span>
                    <span class="tags ml-1">Science</span>
                    <span class="tags ml-1">Biology</span>
                    <span class="tags ml-1">Physics</span>
                  </p>
                  <p>
                    <strong>Hobbies: </strong> Read, out with friends, listen to
                    music, draw and learn new things.
                  </p>
                </div>
              </div>

              <div class="col-md-4 d-flex justify-content-center align-items-center text-center">
                <div className="my-3">
                  <div className="row">
                    <div class="col">
                      <h2 className="text-primary">
                        <strong>13</strong>
                      </h2>
                      <p>Courses</p>
                    </div>

                    <div class="col">
                      <h2 className="text-primary">
                        <strong>36</strong>
                      </h2>
                      <p>Students</p>
                    </div>
                    <div class="col">
                      <h2 className="text-primary">
                        <strong>29</strong>
                      </h2>
                      <p>Reviews</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="m-3">
              <h4 className="text-primary">About</h4>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </div>
            <div class="m-3">
              <h4 className="text-primary">Education</h4>
              Post Graduate, B.Sc, M.Sc
            </div>
          </div>
        </div>
      </div>
      // <div className="profile-header">
      //   <div className="container">
      //     {/* <div className="container">
      //       <div className="edit-profile btn btn-secondary float-right mt-5">
      //         Edit Profile
      //       </div>
      //       <div className="row">
      //         <div className="col">
      //
      //
      //           <p className="text-primary mt-4">
      //             Java Python Android and C# Expert Developer
      //           </p>
      //         </div>
      //       </div>
      //       <div className="row">
      //           <div className="col-md-8">
      //           Lorem Ipsum is simply dummy text of the printing and typesetting
      //           industry. Lorem Ipsum has been the industry's standard dummy
      //           text ever since the 1500s, when an unknown printer took a galley
      //           of type and scrambled it to make a type specimen book. It has
      //           survived not only five centuries, but also the leap into
      //           electronic typesetting, remaining essentially unchanged
      //           </div>

      //           <div className="col-md-4">
      //           <div className="d-flex flex-column">
      //           <div className="col-4"><h5>Students</h5><br></br></div>
      //           <div className="col-4"><h5>Courses</h5><br></br></div>
      //           <div className="col-4"><h5>Reviews</h5><br></br></div>
      //       </div>
      //           </div>
      //       </div>

      //     </div> */}
      //   </div>
      // </div>
    );
  }
}
